import { LivestreamState, Media } from '#types/generated/graphql-types';

const isUpcomingEvent = (media: Media) => {
  return (
    media?.details?.streamState === LivestreamState.Upcoming ||
    media?.details?.streamState === LivestreamState.PreLive
  );
};

export default isUpcomingEvent;
